import { render } from "./InteractionRenderer.vue?vue&type=template&id=76b4989d"
import script from "./InteractionRenderer.vue?vue&type=script&lang=js"
export * from "./InteractionRenderer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__